export default __webpack_public_path__ + "static/media/Icon_material-format-list-bulleted.5ac6f9a9.svg";